import LocaleReceiver from '../locale/LocaleReceiver';
export * from '../locale/LocaleReceiver';
export default LocaleReceiver;
